<template>
    <div>
        <vue-multiselect
            :id="id"
            v-model="value"
            :options="options"
            :searchable="true"
            :allow-empty="allowEmpty"
            :label="labelName"
            :track-by="trackByName"
            :placeholder="placeholderText"
            :select-label="labelSelect"
            :deselect-label="labelDeselect"
            :selected-label="labelSelected"
            :disabled="disabled"
            :show-labels="showLabels"
            :custom-label="customLabel"
            :name="name"
            :options-limit="optionsLimit"
            @select="$emit('dispatch', $event)"
        >
            <span slot="noResult">Brak wyników. Spróbuj zmienić wpisywaną frazę.</span>
        </vue-multiselect>
    </div>
</template>

<script>
import VueMultiselect from 'vue-multiselect'

export default {
  components: {
    VueMultiselect
  },
  props: {
    customLabel: {
      type: Function,
      default: undefined
    },
    allowEmpty: {
      type: Boolean,
      default: true
    },
    showLabels: {
      type: Boolean,
      default: true
    },
    options: {
      type: [Array, String],
      default: () => []
    },
    optionsLimit: {
      type: Number,
      default: 99999
    },
    label: {
      type: String,
      default: 'name'
    },
    trackBy: {
      type: String,
      default: 'id'
    },
    placeholderText: {
      type: String,
      default: ''
    },
    disabled: {
      type: Boolean,
      default: false
    },
    checked: {
      type: [Object, String, Number],
      default: null
    },
    title: {
      type: String,
      default: '',
    },
    name: {
      type: String,
      default: '',
    },
    errors: {
      type: Object,
      default: () => {},
    },
    withLabel: {
      type: Boolean,
      default: true
    },
    onlyLabel: {
      type: Boolean,
      default: false
    }
  },
  data: function () {
    return {
      value: null,
      labelName: this.showLabels ? this.label : undefined,
      trackByName: this.showLabels ? this.trackBy : undefined,
      id: `form_${this.name}`,
      errorText: false,
      formGroupClass: 'form-group',
      labelSelect: Translator.trans('multiselect.select'),
      labelDeselect: this.allowEmpty ? Translator.trans('multiselect.remove') : '',
      labelSelected: Translator.trans('multiselect.selected'),
    }
  },
  watch: {
    errors: function (value) {
      if (value[this.name]) {
        this.errorText = Object.values(value[this.name]).join()
        this.formGroupClass = 'form-group has-error'
      } else {
        this.errorText = false
        this.formGroupClass = 'form-group'
      }
    },
    value: function (value) {
      let emit = null
      if (this.showLabels) {
        emit = value ? value[this.trackBy] : null
      } else {
        emit = value
      }

      this.$emit('input', emit)

    },
    checked: function () {
      this.value = this.prepareValue()
    },
    options: function () {
      if (this.onlyLabel) {
        for (let ind in this.options) {
          if (typeof this.options[ind] === 'object') {
            // eslint-disable-next-line vue/no-mutating-props
            this.options[ind] = this.options[ind][this.label]
          }
        }
      }
      this.value = this.prepareValue()
    },
  },
  mounted() {
    this.value = this.prepareValue()
  },
  methods: {
    prepareValue() {
      if (!this.showLabels) {
        this.$emit('input', this.checked)
        return this.checked
      }

      let prepareValue = {}

      let checked = !isNaN(parseInt(this.checked)) ? parseInt(this.checked) : this.checked
      prepareValue[this.trackBy] = checked
      for (let i = 0; i < this.options.length; i++) {
        if (this.options[i][this.trackBy] === checked) {
          prepareValue[this.label] = this.options[i][this.label]
        }
      }

      this.$emit('input', checked)
      return prepareValue
    }
  },
}
</script>
